import { useCallback } from "react";
import { useFilterState } from "./use-filter-state";
export var useFilterStateWithClearSearch = function (criteria, filters, rehydrateFilterLookups, onClearSearch) {
    var _a = useFilterState(criteria, filters), activeFilters = _a.activeFilters, updateFilters = _a.updateFilters, refreshAllFilters = _a.refreshAllFilters;
    var onClearSearchState = useCallback(function (state) {
        var _a, _b;
        if (onClearSearch) {
            var newState = onClearSearch(state);
            var newCriteria = (_b = (_a = newState === null || newState === void 0 ? void 0 : newState.search) === null || _a === void 0 ? void 0 : _a.criteria) === null || _b === void 0 ? void 0 : _b.criteria;
            if (newCriteria) {
                refreshAllFilters(newCriteria);
                rehydrateFilterLookups(newCriteria);
            }
            return newState;
        }
        else {
            return state;
        }
    }, [onClearSearch, refreshAllFilters, rehydrateFilterLookups]);
    return {
        activeFilters: activeFilters,
        updateFilters: updateFilters,
        refreshAllFilters: refreshAllFilters,
        onClearSearchState: onClearSearchState,
    };
};
//# sourceMappingURL=use-filter-state-with-clear-search.js.map